import { useSelector } from "react-redux";

const useAppState = (func ) =>
{
  return useSelector( state => func ? func( state  ) : state )
}

export default useAppState